// Copyright (c) 2016 Deere & Company

import {
    getRequestTypes,
    resetAllFacets,
    selectAllDealersOnInitialLoad,
    selectAllReturnStatusesOnInitialLoad,
    selectDefaultLoadRequestDates,
    toggleDealerAccountFacetItems,
    toggleReturnStatusFacetItems,
    updateAllPartRequestsDateRangeFacet,
    updateDealerAccountFacetInput,
    updateDealerAccountFacetItem,
    updateReturnStatusFacetItem,
    updateSelectedPartRequestType
} from './facets';
import {
    updateListFilterBy,
    updateListSortBy,
    updateListSortDirection
} from '../../../shared/action-creators/refine-list';
import {
    updateSearchBy,
    updateSearchQueryString
} from '../../search/action-creators/search';
import {exportToExcel} from '../../shared/action-creators/export-to-excel';
import exportToExcelActions from '../../../shared/action-creators/excel-layout-modal-actions-combined';
import {onSearch} from '../../shared/action-creators/search';
import {readAllPartRequests} from './all-part-requests';

export default {
    ...exportToExcelActions,
    exportToExcel,
    getRequestTypes,
    onSearch,
    readAllPartRequests,
    resetAllFacets,
    selectAllDealersOnInitialLoad,
    selectAllReturnStatusesOnInitialLoad,
    selectDefaultLoadRequestDates,
    toggleDealerAccountFacetItems,
    toggleReturnStatusFacetItems,
    updateAllPartRequestsDateRangeFacet,
    updateDealerAccountFacetInput,
    updateDealerAccountFacetItem,
    updateListFilterBy,
    updateListSortBy,
    updateListSortDirection,
    updateReturnStatusFacetItem,
    updateSearchBy,
    updateSearchQueryString,
    updateSelectedPartRequestType
};



// WEBPACK FOOTER //
// ./src/part-requests/all-parts-requests/action-creators/index.js